import 'jquery-flot/excanvas';
import 'jquery-flot';
import 'jquery-flot/jquery.flot.pie';
import 'jquery-flot/jquery.flot.selection';
import 'jquery-flot/jquery.flot.stack';
import 'jquery-flot/jquery.flot.time';




// WEBPACK FOOTER //
// ./webpack/assets/javascripts/bundle_flot.js